/**
 * WhiteLabels API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { getCurrentWhiteLabel } from "../generated/white-labels/white-labels";

import { wrapMethod } from "./utils";

export const whiteLabels = {
  /** @see getCurrentWhiteLabel */
  getCurrentWhiteLabel: wrapMethod(getCurrentWhiteLabel),
} as const;

export type WhiteLabelsApi = typeof whiteLabels;
